var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49984 0.666672H7.33317C7.83317 0.666672 8.1665 1.00001 8.1665 1.50001V7.33334C8.1665 7.83334 7.83317 8.16667 7.33317 8.16667H1.49984C0.999837 8.16667 0.666504 7.83334 0.666504 7.33334V1.50001C0.666504 1.00001 0.999837 0.666672 1.49984 0.666672ZM2.33317 6.5H6.49984V2.33334H2.33317V6.5ZM16.4998 0.666672H10.6665C10.1665 0.666672 9.83317 1.00001 9.83317 1.50001V7.33334C9.83317 7.83334 10.1665 8.16667 10.6665 8.16667H16.4998C16.9998 8.16667 17.3332 7.83334 17.3332 7.33334V1.50001C17.3332 1.00001 16.9998 0.666672 16.4998 0.666672ZM11.4998 6.5H15.6665V2.33334H11.4998V6.5ZM16.4998 9.83334H10.6665C10.1665 9.83334 9.83317 10.1667 9.83317 10.6667V16.5C9.83317 17 10.1665 17.3333 10.6665 17.3333H16.4998C16.9998 17.3333 17.3332 17 17.3332 16.5V10.6667C17.3332 10.1667 16.9998 9.83334 16.4998 9.83334ZM11.4998 15.6667H15.6665V11.5H11.4998V15.6667ZM7.33317 9.83334H1.49984C0.999837 9.83334 0.666504 10.1667 0.666504 10.6667V16.5C0.666504 17 0.999837 17.3333 1.49984 17.3333H7.33317C7.83317 17.3333 8.1665 17 8.1665 16.5V10.6667C8.1665 10.1667 7.83317 9.83334 7.33317 9.83334ZM2.33317 15.6667H6.49984V11.5H2.33317V15.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.dfe816839b5e0ee2c89c095d56238d1d.svg";
export { ForwardRef as ReactComponent };